import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type {
  FinancialSecuritiesResponse,
  RelationsParams,
} from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url?: string;
  params: RelationsParams;
};

type ExecuteProps = {
  url: string;
  params: RelationsParams;
};

export function useContractFinancialSecurities({ url, params }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: ExecuteProps) =>
      axios.request<FinancialSecuritiesResponse>({
        ...baseConfig,
        url: urlTemplate.parse(url).expand({}),
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, params]);

  if (!url) return;

  return request;
}

export type ContractFinancialSecuritiesRequest = ReturnType<
  typeof useContractFinancialSecurities
>;
